import { render, staticRenderFns } from "./select-language.vue?vue&type=template&id=25cb7c83&scoped=true"
import script from "./select-language.vue?vue&type=script&lang=js"
export * from "./select-language.vue?vue&type=script&lang=js"
import style0 from "./select-language.vue?vue&type=style&index=0&id=25cb7c83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cb7c83",
  null
  
)

export default component.exports